module.exports = __webpack_public_path__ + "static/media/Daily Mail Settings.3b5628d8.png";